export default "__VITE_ASSET__CCe53_5t__"